import { useCallback, useMemo, useState } from "react";
import throttle from "lodash/throttle";
import { DownloadProgressCard, SnackbarMessagePropsExt, useSnackbar } from "../components/ui";
import { PipeStreamProgressFunction } from "../utils";

export function useDownloadFileProgress(): PipeStreamProgressFunction {
  const { push, remove } = useSnackbar();
  const [ minimizedDownloads ] = useState(new Set());

  const throttledPush = useMemo(() => throttle(push, 100), [ push ]);

  return useCallback(progress => {
    const key = progress.key || `dl_${progress.id}`;
    if (!minimizedDownloads.has(key)) {
      if (progress.status === "canceled") {
        throttledPush.cancel();
        remove(key);
      } else {
        const finished = progress.status === "completed";

        const messageProps: SnackbarMessagePropsExt = {
          key: key,
          type: "custom",
          autoClose: finished,
          autoCloseTimeout: 3000,
          render: (props) => (
            <DownloadProgressCard
              className={props.className}
              fileName={progress.fileName}
              size={progress.size}
              downloaded={progress.downloaded}
              finished={finished}
              onMinimizeClick={() => {
                minimizedDownloads.add(key);
                throttledPush.cancel();
                props.removeMessage?.();
              }}
            />
          ),
        };

        if (finished) {
          throttledPush.cancel();
          push(messageProps);
        } else {
          throttledPush(messageProps);
        }
      }
    }
  }, [ throttledPush, push, remove, minimizedDownloads ]);
}
